import { render, staticRenderFns } from "./xinyong.vue?vue&type=template&id=6f3ed825&scoped=true"
import script from "./xinyong.vue?vue&type=script&lang=js"
export * from "./xinyong.vue?vue&type=script&lang=js"
import style0 from "./xinyong.vue?vue&type=style&index=0&id=6f3ed825&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3ed825",
  null
  
)

export default component.exports